import Image1 from '@hotjar/shared-assets/images/integrations/zapier/Hotjar-Zapier-Miro.gif';
import Image2 from '@hotjar/shared-assets/images/integrations/zapier/Hotjar-Zapier-Sheets.gif';
import Image3 from '@hotjar/shared-assets/images/integrations/zapier/Hotjar-Zapier-Trello.gif';
import { IntegrationTokenName } from '../domains/api';
import type { Integration } from '../types';

export const zapier: Integration = {
  slug: 'zapier',
  icon: 'zapier',
  name: 'integrations:zapier.title',
  tokenName: IntegrationTokenName.Zapier,
  provider: 'integrations:card.hotjar',
  actionLabel: {
    enable: 'integrations:details.header.zapier-enable',
    disable: 'integrations:details.header.zapier-disable',
    createZap: 'integrations:details.header.zapier-create-zap',
  },
  description: 'integrations:zapier.description-revamp',
  descriptionLarge: 'integrations:zapier.description-large',
  resources: [
    {
      copy: 'integrations:zapier.key-benefits',
      url: 'https://www.hotjar.com/integrations/zapier/',
      icon: 'page_full',
    },
    {
      copy: 'integrations:zapier.using-with-hotjar',
      url: '/articles/1500002049102',
      icon: 'page_full',
    },
    {
      copy: 'integrations:zapier.trello-cards',
      url: 'https://zapier.com/apps/hotjar/integrations/trello',
      icon: 'page_full',
    },
    {
      copy: 'integrations:zapier.ms-teams',
      url: 'https://zapier.com/apps/hotjar/integrations/microsoft-teams/530301/get-messages-in-microsoft-teams-for-new-recordings-collected-in-hotjar',
      icon: 'page_full',
    },
    {
      copy: 'integrations:zapier.excel',
      url: 'https://zapier.com/apps/hotjar/integrations/excel',
      icon: 'page_full',
    },
    {
      copy: 'integrations:zapier.connect-apps',
      url: 'https://zapier.com/apps/hotjar/integrations',
      icon: 'page_full',
    },
  ],
  images: [Image1, Image2, Image3],
  videoUrl: 'https://www.youtube.com/embed/LIPhzx8U4fk',
  gate: 'core.integrations',
  isEnabled: true,
  isAlwaysOn: true,
  settings: null,
};
